class EventEmitter {
    constructor() {
        this.subscriptions = [];
    }

    on(eventName, callback) {
        this.subscriptions.push({ eventName, callback });
    }

    off(eventName, callback) {
        this.subscriptions = this.subscriptions
            .filter(s =>
                !(s.eventName === eventName
                    && s.callback === callback));
    }

    emit(eventName, payload = null) {
        this.subscriptions
            .filter((s) => s.eventName === eventName)
            .forEach((s) => {
                try {
                    s.callback.apply(this, [payload]);
                }
                catch (err) {
                    // eslint-disable-next-line no-console
                    console.error(`EventEmitter subscriber for '${ eventName }' threw:`, err);
                }
            });
    }
}

export default EventEmitter;